import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBuilding = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 20 20",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.666 18.3337V6.66699M11.666 18.3337H6.66602C4.30935 18.3337 3.13018 18.3337 2.39852 17.6012C1.66602 16.8695 1.66602 15.6903 1.66602 13.3337V6.66699C1.66602 4.31033 1.66602 3.13116 2.39852 2.39949C3.13018 1.66699 4.30935 1.66699 6.66602 1.66699C9.02268 1.66699 10.2018 1.66699 10.9335 2.39949C11.666 3.13116 11.666 4.31033 11.666 6.66699M11.666 18.3337H14.9993C16.571 18.3337 17.356 18.3337 17.8443 17.8453C18.3327 17.357 18.3327 16.572 18.3327 15.0003V10.0003C18.3327 8.42866 18.3327 7.64366 17.8443 7.15533C17.356 6.66699 16.571 6.66699 14.9993 6.66699H11.666M5.41602 9.16699H4.58268M8.74935 9.16699H7.91602M5.41602 5.83366H4.58268M5.41602 12.5003H4.58268M8.74935 5.83366H7.91602M8.74935 12.5003H7.91602M15.416 12.5003H14.5827M15.416 9.16699H14.5827",
		stroke: "currentColor",
		strokeWidth: 1.67,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgBuilding;
